// @generated by scripts/sync-html-utils.mjs — DO NOT EDIT.
// Source: backend/services/html/stripPlainText.js
// Run `node scripts/sync-html-utils.mjs` after editing the source.

// Plain-text extractor for journal HTML.
// Canonical source. Frontend mirror at src/utils/_generated/htmlStrip.js
// is regenerated by scripts/sync-html-utils.mjs.
export function stripToPlainText(s) {
  return (s || '')
    .replace(/<img[^>]*>/gi, ' [image] ')
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/(p|div|li|h[1-6]|tr|td|th|blockquote)>/gi, '\n')
    .replace(/<[^>]+>/g, '')
    .replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&apos;/g, "'").replace(/&nbsp;/g, ' ')
    .replace(/[ \t]+/g, ' ')
    .replace(/\n[ \t]*/g, '\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}
